import React from 'react';
import { Typography } from 'antd';
import type { AgentMessage } from '../../types/agent';

const { Text } = Typography;

interface AgentMessageBubbleProps {
  message: AgentMessage;
}

const styles: Record<string, React.CSSProperties> = {
  wrapper: {
    display: 'flex',
    marginBottom: 12,
  },
  wrapperUser: {
    justifyContent: 'flex-end',
  },
  wrapperAgent: {
    justifyContent: 'flex-start',
  },
  bubble: {
    maxWidth: '75%',
    padding: '10px 14px',
    borderRadius: 12,
    whiteSpace: 'pre-wrap',
    lineHeight: 1.5,
  },
  bubbleUser: {
    backgroundColor: '#1677ff',
    color: '#fff',
    borderBottomRightRadius: 4,
  },
  bubbleAgent: {
    backgroundColor: '#f0f0f0',
    color: '#222',
    borderBottomLeftRadius: 4,
  },
};

const AgentMessageBubble: React.FC<AgentMessageBubbleProps> = ({ message }) => {
  const isUser = message.role === 'user';
  return (
    <div
      style={{
        ...styles.wrapper,
        ...(isUser ? styles.wrapperUser : styles.wrapperAgent),
      }}
    >
      <div
        style={{
          ...styles.bubble,
          ...(isUser ? styles.bubbleUser : styles.bubbleAgent),
        }}
      >
        <Text style={{ color: 'inherit', fontSize: 14 }}>{message.text}</Text>
      </div>
    </div>
  );
};

export default AgentMessageBubble;
